import React from "react"
import styled from "styled-components"
import Layout from "../../layout"
import Img from "gatsby-image"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Settings } from "../../../styles/theme"
import { graphql } from "gatsby"
import { ButtonLink } from "../../atoms/buttons"

const MediaTemplateStyled = styled.div`
  position: relative;
  padding-top: 15rem;
  h1 {
    color: ${Settings.primaryColor};
  }
  .meta-data {
    font-size: 1.2rem;
    text-transform: uppercase;
    > b {
      color: ${Settings.primaryColor};
    }
  }
`

const MediaTemplate = ({ data, prev }) => (
  <Layout>
    <MediaTemplateStyled>
      <div className="constraint">
        <p className="meta-data">
          {data.contentfulMediaReleases.publishedDate}
        </p>
        <h1>{data.contentfulMediaReleases.title}</h1>
        {data.contentfulMediaReleases.banner ? (
          <Img fluid={data.contentfulMediaReleases.banner.fluid} />
        ) : (
          ""
        )}
        {data.contentfulMediaReleases.content
          ? documentToReactComponents(data.contentfulMediaReleases.content.json)
          : ""}
      </div>
      <div className="constraint" style={{ padding: "4rem 0" }}>
        <ButtonLink
          text="BACK"
          slug="/trade/singapore-airshow-newsroom"
          type="solid"
        />
      </div>
    </MediaTemplateStyled>
  </Layout>
)

export default MediaTemplate

export const query = graphql`
  query($id: String!) {
    contentfulMediaReleases(id: { eq: $id }) {
      id
      title
      publishedDate(formatString: "DD MMMM YYYY")
      content {
        json
      }
    }
  }
`
